import React from 'react';
import { Modal } from 'antd';
import common from '../../assets/common.js';
import warningIcon from '../../images/warningicon.svg'
import errorIcon from '../../images/erroricon.svg'
import './index.css';

class ReleaseModal extends React.Component {
  constructor(){
    super();
    this.state = {
      modalShow : "release",
      type : "ing"
    }
  }
  handleOk = (data) => {
    var postData = {};
    postData["_url"] = "trigger";
    postData["task_id"] = data.task_id;
    common.request(postData, this, function(obj, data){
      obj.props.showModal("releaseend")
    });
  }
  componentWillReceiveProps(props){
    const data = props.modalData;
    if(data && data.status_code === 1){
      this.setState({
        type : 'error'
      });
    }
  }
  render(){
    const { modalShow, type } = this.state;
    const { modalData, modalType } = this.props;
    const onOk = type === "ing" ? this.handleOk.bind(this, modalData) : this.props.showModal.bind(this, "releaseend")
    return (
      <Modal
        className="uploadModal"
        visible={ modalType === modalShow }
        title="提示"
        onOk={ onOk }
        onCancel={ this.props.showModal.bind(this, "releaseend") }
      >
        {type === "error" && <div className="text-center modal-releaseerr-content">
          <div>
            <img src={ errorIcon } alt="" width="30px" className="mr-8" />
            <span>当前正在发布门禁数据，请稍后重试。</span>
          </div>
        </div>}
        {type === "ing" && <div className="text-center modal-releaseing-content">
          <div>
            <img src={ warningIcon } alt=""  className="mr-8" />
            <span>该项操作需要执行较长时间，您要继续此操作吗？</span>
          </div>
        </div>}
      </Modal>
    )
  }
}
export default ReleaseModal;



// WEBPACK FOOTER //
// ./src/component/manage/releasemodal.js